import type { Passenger } from 'src/common/external/bambi-api/bambiApi';
import { formatPhoneNumber } from 'src/common/formatPhoneNumber';
import { formatFullName } from 'src/common/util/formatFullName';

export function formatPassengerLabel(passenger: Passenger) {
  const baseNameComponent = formatFullName(passenger);
  const phoneNumberComponent = passenger.phone_number
    ? ` ${formatPhoneNumber(passenger.phone_number)}`
    : '';
  const dobComponent = passenger.dob ? ` (DOB: ${passenger.dob})` : '';
  const weightComponent = passenger.weight
    ? ` (Weight: ${passenger.weight} lb.)`
    : '';
  const bariatricComponent = passenger.needs_bariatric_transport
    ? ` (Bariatric)`
    : '';

  const textLabel = (
    baseNameComponent +
    phoneNumberComponent +
    dobComponent +
    weightComponent +
    bariatricComponent
  ).trim();

  return textLabel;
}
